import React from "react";
import {
  Box,
  Typography,
  Collapse,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { Circle, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  customSidebarStyle,
  customStepperStyle,
} from "../Common/styles/stepper";

interface MenuItem {
  label: string;
  matchKey: string;
  link: string;
  enabled: boolean;
}

interface ExpandableMenuProps {
  menuKey: string;
  title: string;
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
  navLinks: MenuItem[];
  matchFunctions: { [key: string]: boolean };
  openMenu: string | null;
  collapsed: boolean;
  onMenuToggle: (menuKey: string, defaultRoute: string) => void;
}

const ExpandableMenu: React.FC<ExpandableMenuProps> = ({
  menuKey,
  title,
  icon,
  activeIcon,
  navLinks,
  matchFunctions,
  openMenu,
  collapsed,
  onMenuToggle,
}) => {
  const isActive = navLinks.some((link) => matchFunctions[link.matchKey]);
  const isOpen = openMenu === menuKey;
  const defaultRoute = navLinks.length > 0 ? navLinks[0].link : "#";

  return (
    <>
      <Box
        className={isActive ? "sider-menu active" : "sider-menu"}
        onClick={() => onMenuToggle(menuKey, defaultRoute)}
      >
        {isActive ? activeIcon : icon}
        {!collapsed && (
          <Box sx={customSidebarStyle}>
            <Typography
              overflow={"hidden"}
              textOverflow={"ellipsis"}
              whiteSpace={"nowrap"}
              title={title}
              variant="body2"
              fontWeight="regular"
            >
              {title}
            </Typography>
            {!isOpen ? <ExpandMore /> : <ExpandLess />}
          </Box>
        )}
      </Box>
      {!collapsed && (
        <Collapse
          in={isOpen}
          timeout={"auto"}
          unmountOnExit
          sx={{ p: "8px 0px" }}
        >
          <Stepper orientation="vertical" sx={customStepperStyle}>
            {navLinks.map((step) => (
              <Step key={step.matchKey}>
                <StepLabel
                  icon={
                    <Circle
                      sx={{
                        color: matchFunctions?.[step.matchKey]
                          ? "#FFFFFF"
                          : "text.secondary",
                        height: "10px",
                        width: "10px",
                      }}
                    />
                  }
                >
                  <NavLink
                    title={step.label}
                    to={step.link}
                    className={({ isActive }) =>
                      isActive && matchFunctions?.[step.matchKey]
                        ? "sider-submenu active"
                        : "sider-submenu"
                    }
                  >
                    <Typography
                      variant="body2"
                      overflow={"hidden"}
                      textOverflow={"ellipsis"}
                      whiteSpace={"nowrap"}
                    >
                      {step.label}
                    </Typography>
                  </NavLink>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Collapse>
      )}
    </>
  );
};

export default ExpandableMenu;
